import React from "react";
import "./Common_Title.css";

const Common_Title = ({
  darkText,
  simpleText,
}) => {
  return (
    <div className="Common_Title">
      <div className="text_content">
        <p className="simple_text">{simpleText} <span className="dark_text">{darkText}</span></p>
      </div>
    </div>
  );
};

export default Common_Title;
